import * as React from 'react';
import { withRouteData, Route } from 'react-static';

import { ContactPageLocale } from '../../components/ContactPage/contactPage.locale';
import ContactPageComponent from '../../components/ContactPage/ContactPage';
import SalesForm from './SalesForm/SalesForm';
import SupportForm from './SupportForm/SupportForm';
import { routePaths } from '../../../config/routePaths';

interface ContactPageProps {
  locale: ContactPageLocale;
}

const ContactPage: React.SFC<ContactPageProps> = ({ locale }) => {
  const renderRouteForAllLang = (
    pathsObject: { [key: string]: string },
    FormComponent: typeof SalesForm | typeof SupportForm,
  ) =>
    Object.entries(pathsObject).map(([lang, path]) => (
      <Route key={lang} exact path={path} render={() => <FormComponent locale={locale.forms} />} />
    ));

  return (
    <ContactPageComponent locale={locale}>
      {renderRouteForAllLang(routePaths.contactSales, SalesForm)}
      {renderRouteForAllLang(routePaths.contactSupport, SupportForm)}
    </ContactPageComponent>
  );
};

export default withRouteData(ContactPage);



// WEBPACK FOOTER //
// /www/client/src/containers/ContactPage/ContactPage.tsx